<template>
  <div class="QuestionBank">
    <AppHeader>题库</AppHeader>
    <AppBox class="appBox" id="appBox">
      <TabsChange
          :tabList="tabList"
          :activeName="activeName"
          :cardType="cardType"
          :stretchType="stretchType"
          @selectInfo="selectInfo"
      ></TabsChange>
      <template v-if="activeName === '0'">
        <TestPaperList :maxHeight="maxHeight"></TestPaperList>
      </template>
      <template v-if="activeName === '1'">
        <TestQuestionList :maxHeight="maxHeight"></TestQuestionList>
      </template>
    </AppBox>
  </div>
</template>

<script>
import AppHeader from "@/components/ui/AppHeader/index.vue";
import AppBox from "@/components/ui/AppBox/index.vue";
import TabsChange from "@/components/TabsChange/index.vue";
import TestPaperList from "@/pages/QuestionBank/TestPaperList.vue";
import TestQuestionList from "@/pages/QuestionBank/TestQuestionList.vue";

export default {
  name: "QuestionBank",
  components: {
    AppHeader,
    AppBox,
    TabsChange,
    TestQuestionList,
    TestPaperList,
  },
  data() {
    return {
      tabList: ["试卷", "试题"],
      cardType: "",
      stretchType: false,
      maxHeight: null,
    };
  },
  computed: {
    activeName: {
      get() {
        return this.$store.state.pluginCenter.activeTab;
      },
      set(value) {
        this.$store.commit("pluginCenter/setData", {
          key: "activeTab",
          value,
        });
      },
    }
  },
  mounted() {
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize); // 移除resize事件监听
  },
  methods: {
    selectInfo(val) {
      this.activeName = val.index;
    },
    // 重置高度
    handleResize() {
      this.$nextTick(() => {
        const el = document.getElementById("appBox");
        if (el.offsetHeight <= 650) {
          this.maxHeight = el.offsetHeight * 0.50;
        } else {
          this.maxHeight = el.offsetHeight * 0.6;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.QuestionBank {
  .appBox {
    height: calc(100vh - 155px);
    min-height: 330px;

    ::v-deep .el-tabs__item {
      color: #ff7918;
      padding: 0 30px 50px 30px;
      margin-left: 30px;
    }

    ::v-deep .el-tabs__item.is-active {
      background-color: #ff7918;
      padding: 0 30px;
      border-radius: 10px;
      color: #ffffff;
      margin-left: 30px;
    }

    ::v-deep .el-tabs__active-bar {
      margin-top: 10px;
      background-color: #e4e7ed;
    }
  }
}
</style>
